<template>
  <keep-alive>
    <div class="wrap-simcard-list">
      <div class="wrap-simcard-list_top">
        <div
            :class="(filters_state)? 'main_fiters_toggler--active' : 'main_fiters_toggler'"
            @click="toggleFiltersState"
        >
          <span
            class="mdi"
            :class="filters_state === true ? 'mdi-filter-remove' : 'mdi-filter'"
            @click="toggleFiltersState"
          />
          <span class="main_fiters_toggler_text">
            {{ filters_state ? translate("filter.hide") : translate("filter.show") }}
          </span>
        </div>

        <div
          class="filter_list"
          :class="filters_state === true ? 'shown' : 'hidden'"
        >
          <div class="simcard-list_fiters">
            <label> {{ translate("simcard_devices_groups.many") }} </label>
            <tree-select
              :options="opt_group"
              :flat="true"
              :placeholder="translate('simcard_devices_groups.many')"
              v-model="filter_simcard_devices.group"
              :multiple="true"
              @input="change_group"
            />
          </div>

          <div
            class="simcard-list_fiters"
            v-if="$store.getters.getClientsList.length > 0"
          >
            <label> {{ translate("client.one") }} </label>
            <tree-select
              :options="client_list"
              :placeholder="translate('client.one')"
              v-model="filter_simcard_devices.client_id"
              :multiple="true"
              @input="change_client"
            />
          </div>

          <div class="simcard-list_fiters">
            <fg-input
                v-model="filter_simcard_devices.msisdn_imsi_iccid"
                class="name"
                type="text"
                placeholder="MSISDN IMSI ICCID"
                label="MSISDN IMSI ICCID"
                @input="change_input"
                :clearable="true"
            />
          </div>

          <div class="simcard-list_fiters"></div>
        </div>

        <div
            class="buttons"
            :class="filters_state === true ? 'shown' : 'hidden'"
        >
          <span
              class="btn btn-fill mdi-refresh mdi btn-warning reset-filters-btn"
              :class="status_filter() ? '' : 'is--no-active'"
              @click.prevent="reset_filter"
          >
            {{ translate("filter.reset") }}
          </span>
        </div>
      </div>

      <div class="response_table">
        <div v-if="load" class="loader">
          <scale-loader />
        </div>
        <table>
          <thead
            ref="tableHead"
            class="table-simcard-list_bg"
            :class="
              filters_state
                ? 'simcard-list_fiters_is--show'
                : 'simcard-list_fiters_is--hidden'
            "
          >
            <tr>
              <th scope="col" class="checkbox_table">
                <input type="checkbox" :checked="checkall" @change="checkAll" />
              </th>
              <th scope="col" class="status table-simcard-list_mob-filters w50">
                <toggle-switch-simcard-status
                  v-model="filter_simcard_devices.status"
                  :disabled="false"
                  :name="name"
                  @toggle="change_status"
                  @selected="selectedMethod()"
                />
              </th>

              <th scope="col" class="table-simcard-list_mob-filters w100">
                {{ translate('simcard_devices.tariff_status') }}
              </th>
              <th scope="col" class="table-simcard-list_mob-filters w100">
                {{ translate('simcard_devices.device_status') }}
              </th>

              <th scope="col" class="table-simcard-list_mob-filters">
                <p>{{ translate("simcard_devices.fid") }}</p>
                <p>{{ translate("simcard_devices.name") }}</p>
              </th>

              <th scope="col" class="table-simcard-list_mob-filters">
                {{ translate("simcard_devices.client") }}
              </th>

              <th scope="col" class="table-simcard-list_mob-filters">
                {{ translate("simcard_devices.group") }}
              </th>

              <th scope="col" class="table-simcard-list_mob-filters">
                {{ translate("simcard_devices.ts_sync") }}
              </th>

              <th scope="col" class="table-simcard-list_mob-filters">
                <tag-list-popup
                  v-model="filter_simcard_devices.mno"
                  :label="translate('simcard_devices.mno')"
                  @input="change_input"
                />
              </th>
              <th scope="col" class="table-simcard-list_mob-filters">
                <tag-list-popup
                  v-model="filter_simcard_devices.apn"
                  :label="translate('simcard_devices.apn')"
                  @input="change_input"
                />
              </th>
              <th scope="col" class="table-simcard-list_mob-filters">
                <tag-list-popup
                  v-model="filter_simcard_devices.number"
                  :label="translate('simcard_devices.number')"
                  @input="change_input"
                />
              </th>
              <th scope="col" class="table-simcard-list_mob-filters">
                <tag-list-popup
                  v-model="filter_simcard_devices.imsi"
                  :label="translate('simcard_devices.imsi')"
                  @input="change_input"
                />
              </th>
              <th scope="col" class="table-simcard-list_mob-filters">
                <tag-list-popup
                  v-model="filter_simcard_devices.iccid"
                  :label="translate('simcard_devices.iccid')"
                  @input="change_input"
                />
              </th>
              <th style="width: 15px" />
            </tr>

            <tr>
              <th v-if="head_tr" class="group_res">
                {{ head_tr }}
              </th>
            </tr>
            <tr v-if="head_tr === 'No result' && filter_simcard_devices.msisdn_imsi_iccid !== ''" class="link_in_sim_profile">
              <router-link :to="'/simcard_profile_list?&msisdn_imsi_iccid=' + filter_simcard_devices.msisdn_imsi_iccid" class="link">
                {{ translate("simcard_devices.search_in_sim_profile")}}
              </router-link>
            </tr>
          </thead>
          <tbody
            ref="tableSimcard"
            style="position: relative"
            @scroll.passive="paint_chart($event)"
          >
            <SimCardDevicesListItem
              v-if="!clean"
              v-for="(item, index) in trs"
              class="simcard_item"
              ref="mySimcard"
              :key="index"
              :index="index"
              :item="item"
              :checked="item.checked"
              @check="resetCheck"
            />

            <tr
              v-if="afterload"
              style="border: none; background-color: transparent"
            >
              <td><scale-loader /></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </keep-alive>
</template>
<script>
import SisSelect from "components/UIComponents/Inputs/SisSelect.vue";
import SimCardDevicesListItem from "./Item/Index.vue";
import ToggleSwitchSimcardStatus from "components/UIComponents/ToggleSwitch/ToggleSwitchSimcardStatus.vue";
import TagListPopup from "components/UIComponents/Tags/TagListPopup.vue";

export default {
  name: "SimCardDevicesList",
  components: {
    SimCardDevicesListItem,
    SisSelect,
    ToggleSwitchSimcardStatus,
    TagListPopup,
  },
  data() {
    return {
      loading: true,
      range: false,
      cur_item: {},
      load: true,
      clean: false,
      top: 0,
      ids: [],
      interval_update: null,
      afterload: false,
      group_cnt: {},
      tableData: {},
      trs: [],
      timer: null,
      timer_res: null,
      name: "",
      cur_pages: 0,
      pages: 0,
      timer_chart: null,
      menuData: {},
      rendList: [],
      resizeList: [],
      checkall: false,
      was_checkall: false,
      uncheckList: {},
      filter_simcard_devices: {},
      head_tr: "",
      group_head: [],
      status_option: [],
      filters_state:
        this.localStorage.getItem("filters_state") !== null
          ? this.localStorage.getItem("filters_state") === "true"
          : true,
      date: [],
      dateReport: [],
      sims_sort: "asc",
    };
  },
  computed: {
    client_list() {
      let list = [];
      if (this.$store.getters.getClientsList.length > 0) {
        for (let client of this.$store.getters.getClientsList) {
          list.push({ id: client.id, label: client.name });
        }
      }
      return list;
    },
    opt_group() {
      return this.$store.getters.getSimcardDevicesGroupsTree;
    },
    url() {
      return this.$route.fullPath;
    },
  },

  watch: {
    url() {
      if (this.$route.name === "simcard_devices_list") {
        this.check_query();
        this.change_input();
      }
    },
    filter_simcard_devices: {
      deep: true,
      handler() {
        let string = "?";
        for (let key in this.filter_simcard_devices) {
          switch (key) {
            case 'client_id':
            case 'group':
            case 'mno':
            case 'msisdn_imsi_iccid':
              if (this.filter_simcard_devices[key].length > 0){
                string += '&' + key + '=' + this.filter_simcard_devices[key]
              }
              break
            case "status":
              string += "&" + key + "=" + JSON.stringify(this.filter_simcard_devices[key]);
              break
          }
        }
        history.pushState(null, null, this.$route.path + string);
      },
    },
    "filter_simcard_devices.msisdn_imsi_iccid":{
      handler(){
        if (this.filter_simcard_devices.msisdn_imsi_iccid !== ""){
          this.filter_simcard_devices.msisdn_imsi_iccid = this.filter_simcard_devices.msisdn_imsi_iccid.replace(" ", "")
        }
      }
    },
    opt_group() {
      this.$nextTick(() => {
        if (this.group_head.length > 0) {
          this.group_head[0].$el.style.display = "none";
          if (this.$refs.tableSimcard.scrollTop <= 50) {
            this.head_tr = this.group_head[0].$el.firstChild.innerHTML;
          }
        }
      });
    },
    tableData() {
      let trs = []; // 0 - название группы, 1 - элемент
      let t = {};
      this.group_head = [];
      for (let i in this.tableData) {
        t = {
          type: 0,
          id: i,
          count: this.group_cnt[i].cnt,
          online: +this.group_cnt[i].online,
        };
        trs.push(t);
        for (let j in this.tableData[i]) {
          this.tableData[i][j].checked = false;
          if ((this.online && this.tableData[i][j].status) || !this.online) {
            this.tableData[i][j].type = 1;
            this.tableData[i][j].checked = this.was_checkall;
            trs.push(this.tableData[i][j]);
          }
        }
        // trs.push(t)
      }

      if (trs.length === 0) {
        this.head_tr = "No result";
        this.trs = [];
      } else {
        this.$set(this, "trs", trs);
      }

      this.load = false;
      this.afterload = false;
      this.$nextTick(this.mountItem);
      return true;
    },
  },
  created() {
    this.init();
    window.addEventListener("resize", this.handleResize);
  },
  activated() {
    this.init();
    this.$refs.tableSimcard.scrollTop = this.top;
    if (this.$store.getters.getSimcardDevicesListChange) {
      this.$store.commit("setSimcardDevicesListChange", false);
    }
    clearInterval(this.interval_update);
    this.change_input();

    window.addEventListener("resize", this.handleResize);
  },

  beforeDestroy: function () {
    window.removeEventListener("resize", this.handleResize);
  },

  deactivated() {
    this.top = this.$refs.tableSimcard.scrollTop;
    clearInterval(this.interval_update);
    window.removeEventListener("resize", this.handleResize);

    this.ids = []
    this.tableData = []
  },

  methods: {
    check_query() {
      if (Object.keys(this.$route.query).length > 0) {
        for (let key in this.$route.query) {
          switch (key) {
            case 'client_id':
            case "group":
            case "mno":
              this.filter_simcard_devices[key] = this.$route.query[key].split(',').map((item) => {
                if (item) return +item
              })
              break;
            case "status":
              let status = JSON.parse(this.$route.query.status);
              for (let statusKey in status) {
                if (["online"].indexOf(statusKey) > -1) {
                  this.filter_simcard_devices.status[statusKey] =
                      status[statusKey];
                }
              }
              break;
            case 'msisdn_imsi_iccid':
              this.filter_simcard_devices[key] = this.$route.query[key]
              break;
          }
        }
      }
    },
    get_simcard() {
      this.ids = [];
      this.load = true;
      this.clean = true;
      this.group_head = [];

      clearInterval(this.interval_update);
      this.interval_update = setInterval(
        this.update_status,
        this.$store.getters.getSimcardDevicesListUpdate
      );
      this.rendList = [];

      // this.$store.dispatch('setSimcardDevicesFilter', this.filter_simcard_devices)
      this.localStorage.setItem("filter_simcard_devices", JSON.stringify(this.filter_simcard_devices));

      this.$http.v1.getPagesSimcards(this.filter_simcard_devices,(response) => {
        this.pages = response.data.pages;
        for (let group of response.data.group) {
          this.group_cnt[group.group_id] = group;
        }
        this.hash = response.data.hash;

        this.$http.v1.getSimcardList( { ...this.filter_simcard_devices, page: (this.cur_page = 0) }, (response) => {
          this.tableData = { ...response.data.sim };
          this.ids = [...response.data.ids];
          this.clean = false;
        });
      });
    },
    update_status() {
      this.date = new Date();
      this.$http.v1.getPagesSimcards(
        this.filter_simcard_devices, (response) => {
          this.page = response.data.pages;
          this.group = response.data.group;
          for (let i = 0; i <= this.cur_page; i++) {
            setTimeout(() => {
              this.$http.v1.getSimcardList(
                { ...this.filter_simcard_devices, page: i },
                (response) => {
                  for (let i in response.data.sim) {
                    if (this.tableData[i] === undefined) {
                      this.tableData[i] = {};
                    }
                    for (let j in response.data.sim[i]) {
                      if (this.tableData[i][j] === undefined) {
                        this.tableData[i][j] = {};
                      }
                      this.tableData[i][j] = response.data.sim[i][j];
                      this.tableData[i][j].offline =
                        response.data.sim[i][j].offline;
                    }
                  }
                }
              );
            }, 300);
          }
        }
      );
    },
    change_client() {
      this.change_input();
    },
    change_group() {
      this.change_input();
    },
    change_status(name, value) {
      this.filter_simcard_devices.status[name] = value;
      this.change_input();
    },

    handleResize() {
      if (this.timer_res !== null) {
        clearTimeout(this.timer_res);
      }
      this.timer_res = setTimeout(() => {
        this.resizeList = [...this.$refs.mySimcard];
        this.paint_chart();
      }, 300);
    },
    checkAll() {
      this.checkall = !this.checkall;
      this.was_checkall = this.checkall;
      this.tableData = { ...this.tableData };
      this.uncheckList = {};
    },
    resetCheck(check, dev_id) {
      if (this.checkall) {
        this.was_checkall = true;
      }
      if (
        this.was_checkall &&
        !check &&
        this.uncheckList[dev_id] === undefined
      ) {
        this.uncheckList[dev_id] = 1;
      } else {
        delete this.uncheckList[dev_id];
      }
      this.checkall = false;
    },
    status_filter() {
      for (let i in this.filter_simcard_devices) {
        if (i === "status") {
          for (let j in this.filter_simcard_devices.status) {
            if (this.filter_simcard_devices.status[j]) {
              return true;
            }
          }
        } else {
          if (this.filter_simcard_devices[i].length > 0) {
            return true;
          }
        }
      }
      return false;
    },
    get_filter() {
      let arr = {
        mno: [],
        apn: [],
        group: [],
        number: [],
        iccid: [],
        imsi: [],
        client_id: [],
        status: { online: false },
        msisdn_imsi_iccid: ""
      };
      let res = {};

      let filter = JSON.parse(
        this.localStorage.getItem("filter_simcard_devices")
      );

      if (filter !== null) {
        for (let i in arr) {
          if (filter[i] !== undefined) {
            res[i] = filter[i];
          } else {
            res[i] = arr[i];
          }
        }
      } else {
        res = arr;
      }
      return res;
    },

    init() {
      this.filter_simcard_devices = this.get_filter();
      this.check_query();
      this.date = new Date();
    },

    paint_chart() {
      let tmpRend = [];
      let table = this.$refs.tableSimcard;
      for (let i in this.group_head) {
        if (
          this.group_head[i].$el.offsetTop <=
          table.scrollTop - this.group_head[i].$el.clientHeight
        ) {
          this.head_tr = this.group_head[i].$el.firstChild.innerHTML;
        }
      }
      for (let i in this.resizeList) {
        if (
          this.resizeList[i].$el.offsetTop > table.scrollTop - 40 &&
          this.resizeList[i].$el.offsetTop <
            table.scrollTop + table.clientHeight + 40
        ) {
          if (this.resizeList[i].chartStatus === true) {
            this.resizeList[i].resize = !this.resizeList[i].resize;
          }
        } else {
          tmpRend.push(this.resizeList[i]);
        }
      }

      if (tmpRend.length > 0) {
        this.resizeList = [...tmpRend];
      }

      tmpRend = [];
      for (let i in this.rendList) {
        if (
          this.rendList[i].$el.offsetTop > table.scrollTop - 40 &&
          this.rendList[i].$el.offsetTop <
            table.scrollTop + table.clientHeight + 40
        ) {
          this.rendList[i].chartStatus = true;
        } else {
          tmpRend.push(this.rendList[i]);
        }
      }
      this.rendList = tmpRend;
      if (
        table.scrollTop >= table.scrollHeight - table.clientHeight * 3 &&
        !this.afterload
      ) {
        if (this.cur_page < this.pages) {
          this.add_simcard_in_list();
        }
      }
    },

    mountItem() {
      if (this.trs.length === 0) {
        return false;
      }
      let length =
        this.$refs.mySimcard.length < 25 ? this.$refs.mySimcard.length : 25;

      // for (let i = 0; i < length; i++) {
      //   this.$refs.mySimcard[i].chartStatus = true
      // }
      if (length < this.$refs.mySimcard.length) {
        for (let i = 25; i < this.$refs.mySimcard.length; i++) {
          this.rendList.push(this.$refs.mySimcard[i]);
        }
      }
      for (let i = 0; i < this.$refs.mySimcard.length; i++) {
        if (this.$refs.mySimcard[i].item.type === 0) {
          this.group_head.push(this.$refs.mySimcard[i]);
        }
      }
      if (this.group_head.length > 0) {
        this.group_head[0].$el.style.display = "none";
        // if (this.head_tr === '' || this.head_tr === 'No result') {
        if (this.$refs.tableSimcard.scrollTop <= 50) {
          this.head_tr = this.group_head[0].$el.firstChild.innerHTML;
        }
      }
    },
    change_input() {
      if (this.timer !== null) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(this.get_simcard, 1000);
    },

    reset_filter() {
      this.filter_simcard_devices = {
        mno: [],
        apn: [],
        group: [],
        number: [],
        client_id: [],
        iccid: [],
        imsi: [],
        status: { online: false },
        msisdn_imsi_iccid: ""
      };
      this.change_input();
    },

    add_simcard_in_list() {
      if (this.cur_page + 1 < this.pages) {
        this.afterload = true;
        this.$http.v1.getSimcardList(
          { ...this.filter_simcard_devices, page: ++this.cur_page },
          (response) => {
            let tmp = { ...this.tableData };
            for (let i in response.data.sim) {
              if (tmp[i] === undefined) {
                tmp[i] = {};
              }
              for (let j in response.data.sim[i]) {
                tmp[i][j] = response.data.sim[i][j];
              }
            }
            this.tableData = { ...tmp };
            this.ids = [...this.ids, ...response.data.ids];
          }
        );
      }
    },
    toggleFiltersState() {
      this.filters_state = !this.filters_state;
      this.localStorage.setItem("filters_state", this.filters_state);
    },
  },
};
</script>
<style lang="scss" scoped>
.wrap-simcard-list {
  display: flex;
  flex-direction: column;
  height: 100%;
  .response_table {
    padding: 0;
    .checkbox_table {
      width: 30px;
      height: 50px;
    }
    .simcard_item {
      cursor: pointer;
      &:hover {
        background-color: #eee;
        color: black;
        tr {
          background-color: #f1f1f1;
        }
      }
    }
  }
  &_top {
    padding: 30px 1vh 1vh;
    margin-bottom: -1px;
    background: #fff;
    width: 100%;
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border: 1px solid #dddddd;
    border-bottom: none;
    .filter_list {
      width: calc(100% - 200px);
      display: flex;
      justify-content: space-between;
      align-items: center;
      .simcard-list_fiters {
        width: 100%;
        transition: all ease 0.15s, opacity ease 0.25s;
        box-sizing: border-box;
        margin: 0 5px;

        .form-group{
          margin-bottom: 0;
        }

        &:last-child {
          margin-right: 0;
        }
        &:first-child {
          margin-left: 0;
        }
      }
      &.shown {
        opacity: 1;
      }
      &.hidden {
        opacity: 0;
      }
    }

    .reset-filters-btn {
      padding: 0 10px;
      margin-bottom: 10px;
      border: 1px solid;
      width: 165px;
    }
  }
}
.table-simcard-list_mob-filters {
  font-weight: bold;
  font-size: 0.95rem;
  letter-spacing: 0.1rem;
  text-transform: uppercase;
  &__traffic {
    font-size: 0.95rem;
    letter-spacing: 0.1rem;
    text-transform: uppercase;
    cursor: pointer;
    .mdi {
      transition: 0.2s;
      &::before {
        transform: rotate(180deg);
      }
      &.reverse::before {
        transform: rotate(0);
      }
    }
  }
  p{
    font-size: 10px;
    margin-bottom: 0;
  }
}
.link_in_sim_profile{
  display: block;
  text-align: center;
  padding: 10px 0;
  .link{
    font-weight: bold;
    color: #3f93d3;
  }
}
</style>
